// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03ad772f","553":"92a7d516"}[chunkId] + ".chunk.js";
};